import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Vacuum = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M13.184 14.318a.334.334 0 0 1 .298 0l2 1a.333.333 0 0 1 .185.299v.666c0 .184-.15.333-.334.333h-4a.333.333 0 0 1-.333-.333v-.667c0-.126.071-.241.184-.298l2-1Zm-1.517 1.505v.127H15v-.127l-1.667-.834-1.666.833Z" />
        <path d="M13.333 8.95c.184 0 .334.148.334.333v5.333a.333.333 0 0 1-.667 0V9.283c0-.185.15-.334.333-.334ZM10.668 1.95a2.333 2.333 0 0 0-2.333 2.333v.667a.333.333 0 1 1-.667 0v-.667a3 3 0 1 1 6 0v3a.333.333 0 1 1-.667 0v-3a2.333 2.333 0 0 0-2.333-2.333ZM7.334 13.282a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666Zm-2 1.333a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" />
        <path d="M1.798 8.082a5 5 0 0 1 3.536-1.465H8c.185 0 .334.15.334.334v4.333a.333.333 0 0 1-.667 0v-4H5.334A4.333 4.333 0 0 0 1 11.617v3.333a1 1 0 0 0 1 1h2a.333.333 0 0 1 0 .667H2A1.666 1.666 0 0 1 .334 14.95v-3.333a5 5 0 0 1 1.464-3.535Z" />
        <path d="M5.667 7.283v2a3.333 3.333 0 0 1-3.333 3.333h-2v-.666h2A2.667 2.667 0 0 0 5 9.283v-2h.666Z" />
      </g>
    </svg>
  );
};

Vacuum.category = 'product-category';

Vacuum.displayName = 'Vacuum';
